import { createStoreon } from 'storeon';
import { storeonDevtools, storeonLogger } from 'storeon/devtools';
import { cookies } from 'modules/cookies';
import { collections } from 'modules/collections';
import { globalState } from 'modules/global';
import { modelJson } from 'modules/model-json';
import { products } from 'modules/products';
import { relatedServices } from 'modules/related-services';
import { shops } from 'modules/shops';
import { services } from 'modules/services';
import { leads } from 'modules/leads';
import { landings } from 'modules/landings-info';
import { serviceCategories } from 'modules/service-categories';

import { State, Events } from './types';

export const createStore = () =>
  createStoreon<State, Events>([
    collections,
    cookies,
    ...globalState,
    landings,
    relatedServices,
    serviceCategories,
    shops,
    services,
    modelJson,
    products,
    leads,
    !__IS_SERVER__ && process.env.NODE_ENV !== 'production' && storeonDevtools,
    !__IS_SERVER__ && process.env.NODE_ENV !== 'production' && storeonLogger,
  ]);
